// extracted by mini-css-extract-plugin
export default {"phoneContainer":"style_phoneContainer__ZVSeV"};